export default {
  postCheck: (state) => {
    return state.postCheck;
  },

  postCheck2: (state) => {
    return state.postCheck2;
  },

  postCheckHeader: (state) => {
    return state.postCheckHeader;
  },

  postCheckFiscalYear: (state) => {
    return state.postCheckFiscalYear;
  },

  loginCheck: (state) => {
    return state.loginCheck;
  },

  forgotCheck: (state) => {
    return state.forgotCheck;
  },
  forgotBtn: (state) => {
    return state.forgotBtn;
  },

  userProfile: (state) => {
    return state.userProfile;
  },

  loadingBtn: (state) => {
    return state.loadingBtn;
  },

  updateModule: (state) => {
    return state.updateModule;
  },

  userSession: (state) => {
    return state.userSession;
  },

  errorMessage: (state) => {
    return state.errorMessage;
  },
  modalVisibility: (state) => {
    return state.modalVisibility;
  },

  breadcrumbs: (state) => {
    return state.breadcrumbs;
  },

  themeMode: (state) => {
    return state.themeMode;
  },
  themeColor: (state) => {
    return state.themeColor;
  },

  getTabState: (state) => (tabName) => {
    return state.tabsData[tabName] || null;
  },

  // تمام tabs state
  getAllTabsState: (state) => {
    return state.tabsData;
  },

  // لیست تب‌های فعال برای keep-alive
  getActiveTabs: (state) => {
    return state.activeTabs;
  },

  // تعداد تب‌های باز
  getOpenTabsCount: (state) => {
    return state.activeTabs.length;
  },
  // Static Getters ---------------------------------------------------------------
  cartableIds: (state) => {
    return state.cartableIds;
  },

  subSystems: (state) => {
    return state.subSystems;
  },

  attachmentType: (state) => {
    return state.attachmentType;
  },
};
